/**
 * Created by slava on 3/30/17.
 */

const LoaderScene = cc.Scene.extend({
    ctor: function (nextSceneBundles, callback) {
        this._super();

        this.sceneComponent = ComponentMap.attach(this, new SceneComponent({
            sceneName: cleverapps.Environment.SCENE_LOADER
        }));

        this.debugId = "LoadingScene";

        this.prevSceneBundles = [];
        this.bundles = [];

        this.customProgressReport = connector.platform.hasNativeLoadingScreen;

        this.percent = 0;
        this.resourcesProgress = 0;
        LoaderScene.progressListener = this.createListener(this.updateProgress);
        addCleaner(this, () => {
            LoaderScene.progressListener = undefined;
        });
        this.updateProgress();

        callback = cleverapps.wait(2, callback);

        this.createBackground(callback);

        this.sceneComponent.onResize();
        
        this.sceneName = cleverapps.Environment.SCENE_LOADER;
        cleverapps.environment.setScene(this.sceneName);

        LoaderScene.startLoading(nextSceneBundles, {
            onSuccess: () => callback(),
            onFailure: (errors) => this.onLoadFailure(errors),
            onProgress: (loaded, total) => this.onProgress(loaded, total),
            onRetry: (attempt) => this.onRetry(attempt)
        });

        if (window.wechatFirstScreen) {
            this._canvas.active = false;
        }

        this.bundles.push(...nextSceneBundles);
    },

    createBackground: function (callback) {
        const backgroundBundle = this.getBackgroundBundle();
        if (!backgroundBundle) {
            callback();
            return;
        }

        let onShowAgeRestriction = undefined;

        callback = cleverapps.wait(2, LoaderScene.track("background", callback));

        if (connector.platform.oneOf(connector.SAMSUNG)) {
            onShowAgeRestriction = function () {
                cleverapps.timeouts.setTimeout(callback, 3000);
            };
        } else {
            callback();
        }

        this.loaderBackground = new LoaderSceneBackground({ bundleId: backgroundBundle, onShowAgeRestriction });
        this.screen.addChild(this.loaderBackground);

        const backgroundCallback = cleverapps.waitNoMore(1000, callback);

        const loaderSceneBundles = [backgroundBundle];

        if (cleverapps.config.debugMode) {
            loaderSceneBundles.push("dev_resources");
        }

        cleverapps.bundleLoader.loadBundles(loaderSceneBundles, {
            onSuccess: this.createListener(() => {
                this.loaderBackground.addBackground();
                backgroundCallback();
                if (!this.customProgressReport) {
                    this.loaderBackground.addProgressBar();
                }
            })
        });

        this.bundles.push(...loaderSceneBundles);
    },

    getBackgroundBundle: function () {
        const customBackground = Object.values(LoaderSceneBackground.BACKGROUNDS)
            .find((background) => background && bundles[background.bundle] && background.available && cleverapps.user.checkAvailable(background.available));

        const wideModeBackground = ["loading_scene_vertical", "loading_scene_square", "loading_scene_horizontal"][cleverapps.resolution.mode];

        return [
            customBackground,
            wideModeBackground,
            `loading_scene_${cleverapps.config.orientation}`,
            "loading_scene_vertical",
            "loading_scene_square",
            "loading_scene_horizontal"
        ].find((name) => name && bundles[name]);
    },

    onProgress: function (loaded, total) {
        this.resourcesProgress = total ? loaded / total : 1;
        this.updateProgress();
    },

    updateProgress: function () {
        const values = Object.values(LoaderScene.progress);
        const trackedProgress = values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : 1;
        const percent = Math.floor(this.resourcesProgress * 80 + trackedProgress * 20);

        if (percent <= this.percent) {
            return;
        }

        this.percent = percent;

        if (this.customProgressReport) {
            connector.platform.reportLoadingProgress(percent);
        }

        if (connector.platform.oneOf(connector.WECHAT)) {
            this.logLoadingProgress(percent);
        }

        if (this.loaderBackground) {
            this.loaderBackground.setProgressBarPercentage(percent);
        }
    },

    // the first retry often succeeds (samsung cdn), the text would only flash
    onRetry: function (attempt) {
        if (attempt >= 2 && this.loaderBackground) {
            this.loaderBackground.showSlowLoading();
        }
    },

    logLoadingProgress: cleverapps.accumulate(5000, (percent) => {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LOADER_PROGRESS + percent);
    }),

    onLoadFailure: function (errors) {
        ErrorHandler.showRestartWindow({ errors });
    }
});

LoaderScene.startLoading = function (bundleNames, options) {
    LoaderScene.start = Date.now();

    options = options || {};

    const urls = [].concat(...bundleNames.map((name) => bundles[name].listUrls()));

    const dictionaries = bundleNames.map((name) => bundles[name].urls[`dictionary_${cleverapps.settings.language}`]).filter(Boolean);
    urls.push(...dictionaries);

    cleverapps.bundleLoader.loadUrls(urls, {
        tries: 10,
        onRetry: options.onRetry,
        onProgress: (loaded, total) => options.onProgress(loaded, total),
        onSuccess: () => {
            options.onProgress(urls.length, urls.length);

            cleverapps.bundleLoader.loadBundles(bundleNames, {
                onSuccess: options.onSuccess
            });
        },
        onFailure: options.onFailure
    });
};

LoaderScene.progress = {};

LoaderScene.track = function (name, callback) {
    LoaderScene.progress[name] = 0;

    return (...args) => {
        LoaderScene.progress[name] = 1;

        if (LoaderScene.progressListener) {
            LoaderScene.progressListener();
        }

        return callback(...args);
    };
};

LoaderScene.getLoadingText = function (slow) {
    const messages = slow ? {
        en: "Slow connection, still loading",
        ru: "Медленное соединение, загружаем",
        ja: "接続が遅いです。読み込み中",
        zh: "网络较慢，正在加载",
        es: "Conexión lenta, cargando",
        de: "Langsame Verbindung, wird geladen",
        pt: "Conexão lenta, carregando",
        it: "Connessione lenta, caricamento in corso",
        ar: "اتصال بطيء، جار التحميل",
        ko: "연결이 느립니다. 로드 중",
        tr: "Bağlantı yavaş, yükleniyor",
        nl: "Trage verbinding, bezig met laden",
        fr: "Connexion lente, chargement"
    } : {
        en: "Loading",
        ru: "Загрузка",
        ja: "読み込み中",
        zh: "载入中",
        es: "cargando",
        de: "Wird geladen",
        pt: "Carregando",
        it: "Caricamento in corso",
        ar: "جار التحميل",
        ko: "로드 중",
        tr: "Yükleniyor",
        nl: "bezig met laden",
        fr: "chargement"
    };

    return `${messages[cleverapps.settings.language] || messages.en}...`;
};
